export default {"src":"/_next/static/media/puglia.0aee28f8.svg","height":466,"width":585,"blurWidth":0,"blurHeight":0};